export const instructionTooltipAgenda = {
  title: "",
  eventName: "${eventName} - Nome do evento.",
  participante: "${participantName} - Participante que receberá o e-mail.",
  sessionName: "${sessionName} - Nome da sessão.",
  sessionDate: "${sessionDate} - Data da sessão",
  sessionHour: "${sessionHour} - Hora da sessão.",
  totalTickets: "${totalTickets} - Total de ingressos.",
  adresSession: "${addresSession} - Local da sessão"  
}